import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Guard de rota: só renderiza os filhos para administradores.
 * Não-admin é redirecionado pra home. Gate de FRONT — o backend continua
 * permitindo; serve para esconder a feature na UI temporariamente.
 */
export default function AdminOnly({ children }) {
  const { user } = useAuth();
  if (!user) return null; // auth ainda carregando
  if (user.perfil !== 'administrador') return <Navigate to="/" replace />;
  return children;
}
